import { PropertyType } from '../../../common';

export const mapToFormData = (data: PropertyType): PropertyType => {
	const formData = new FormData();
	const keys = Object.keys(data);

	keys.forEach((key) => {
		if (key !== 'filters') {
			formData.append(key, data[key]);
		} else {
			formData.append(key, JSON.stringify(data[key]));
		}
	});
	return formData;
};

export const mapFilters = (filters: PropertyType[]): PropertyType => {
	return filters.reduce((acc, filter) => {
		acc[filter.name] = filter.value;
		return acc;
	}, {});
};

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return {
		template: data,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	id: data.id,
	name: data.name,
	user_id: data.userId,
	report_name: 'gambling_report',
	filters: mapFilters(data.filters),
});
